import styled from 'styled-components';

const WizardSecodaryTitle = styled.span`
  font-weight: 300;
  /* margin-bottom: 30px; */
  max-width: 300px;
  text-align: center;
  font-size: 0.9rem;
`;

export { WizardSecodaryTitle };
